import React from 'react';
import { isNotEmpty, parseClasses } from '../../../lib/ep';

const LeveledHTMLText = (props) => {
	if(!isNotEmpty(props, 'children')) return null;

	const is_text_block = props?.is_text_block ?? true;

	const _class = props?._class ?? {};
	let classname = parseClasses(((is_text_block) ? 'gui_text_block' : ''), _class, 'generic_item');

	const parseHTML = props?.parseHTML ?? ((typeof props.children == 'object') ? false : true);

	let item_props = {...props};
	delete item_props._class;
	delete item_props.children;
	delete item_props.parseHTML;
	delete item_props.is_text_block;

	if(!parseHTML) {
		return (
			<div
				class={classname}
				{...item_props}
			>{props.children}</div>
		)
	}

	return (
		<div
			class={classname}
			{...item_props}
			dangerouslySetInnerHTML={{ __html:props.children.replace(/\n/g, '<br />')}}
		/>
	)
};

export default LeveledHTMLText;